var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBell = function SvgBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1dbadf"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m12 2c.5523 0 1 .44772 1 1v1.07389c1.5711.2388 2.7663 1.03343 3.5886 2.04552.9635 1.18582 1.4114 2.66086 1.4114 3.88059v7h1c.5523 0 1 .4477 1 1s-.4477 1-1 1h-14c-.55228 0-1-.4477-1-1s.44772-1 1-1h1v-7c0-1.21973.44791-2.69477 1.41139-3.88059.82232-1.01209 2.01749-1.80672 3.58861-2.04552v-1.07389c0-.55228.4477-1 1-1zm-4 15h8v-7c0-.78027-.3021-1.80523-.9636-2.61941-.6363-.78311-1.6086-1.38059-3.0364-1.38059s-2.40011.59748-3.03639 1.38059c-.66152.81418-.96361 1.83914-.96361 2.61941z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 20h-4c0 1 .8 2 2 2s2-1 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m12 7.5c.5523 0 1 .44772 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.55228.4477-1 1-1z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 15c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bell.2fa3be67.svg";
export { ForwardRef as ReactComponent };